import { render, staticRenderFns } from "./AffiliateRevenueTable.vue?vue&type=template&id=0b6708aa&scoped=true&"
import script from "./AffiliateRevenueTable.vue?vue&type=script&lang=babel&"
export * from "./AffiliateRevenueTable.vue?vue&type=script&lang=babel&"
import style0 from "./AffiliateRevenueTable.vue?vue&type=style&index=0&id=0b6708aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6708aa",
  null
  
)

export default component.exports